function createTcfComms () {
  let frame = window
  let cmpFrame

  while (frame) {
    try {
      if (frame.frames.__tcfapiLocator) {
        cmpFrame = frame
        break
      }
    } catch (ignore) {}

    if (frame === window.top) {
      break
    }
    frame = frame.parent
  }
  return cmpFrame
}

export default class {
  constructor () {
    this.cmpCallbacks = {}
    this.cmpFrame = createTcfComms()
    this.call = this.call.bind(this)
    this.postMessageHandler = this.postMessageHandler.bind(this)
    window.addEventListener('message', this.postMessageHandler, false)
  }

  call (shouldPersistCallback, cmd, callback) {
    const callId = Math.random() + ''
    const msg = {
      __tcfapiCall: {
        command: cmd,
        // parameter: arg,
        version: 2,
        callId: callId
      }
    }

    this.cmpCallbacks[callId] = {
      callback,
      shouldPersistCallback
    }
    this.cmpFrame.postMessage(msg, '*')
  }

  postMessageHandler (event) {
    let json = {}
    try {
      json = typeof event.data === 'string' ? JSON.parse(event.data) : event.data
    } catch (ignore) {}

    const payload = json.__tcfapiReturn
    if (payload) {
      if (typeof (this.cmpCallbacks[payload.callId] && this.cmpCallbacks[payload.callId].callback) === 'function') {
        this.cmpCallbacks[payload.callId].callback(payload.returnValue, payload.success)
        if (!this.cmpCallbacks[payload.callId].shouldPersistCallback) {
          this.cmpCallbacks[payload.callId] = null
        }
      }
    }
  }
}
